import { PlaceEstimate } from '../types/results.types';

const groupKey = (person: { id: number; group_id?: number | null }): number =>
  person.group_id ?? person.id;

export const countUniqueDecisionMakers = (
  places: PlaceEstimate[],
  selectedPlaceIds?: Set<number>,
): number => {
  const seen = new Set<number>();
  places.forEach((place) => {
    if (selectedPlaceIds && !selectedPlaceIds.has(place.place_id)) return;
    place.people.forEach((person) => seen.add(groupKey(person)));
  });
  return seen.size;
};

export const selectPlacesWithinBudget = (places: PlaceEstimate[], budget: number): Set<number> => {
  const selected = new Set<number>();
  const seen = new Set<number>();
  let remaining = budget;
  places.forEach((place) => {
    const fresh = new Set(place.people.map(groupKey).filter((key) => !seen.has(key)));
    if (remaining >= fresh.size) {
      selected.add(place.place_id);
      fresh.forEach((key) => seen.add(key));
      remaining -= fresh.size;
    }
  });
  return selected;
};
